import { MMKV } from 'react-native-mmkv';
import { StateStorage } from 'zustand/middleware';
import { MMKVStoreKeyMap } from './mmkvStoreKeyMap';

export const mmkvHomeFeedPersistence = new MMKV({
  id: MMKVStoreKeyMap.feedStore,
});

export const zustandHomeFeedStorage: StateStorage = {
  setItem(name: string, value: string) {
    return mmkvHomeFeedPersistence.set(name, value);
  },
  getItem(name: string) {
    const value = mmkvHomeFeedPersistence.getString(name);
    return value ?? null;
  },
  removeItem(name: string) {
    return mmkvHomeFeedPersistence.delete(name);
  },
};
